import { FormControlLabel, Radio } from '@mui/material';
import React from 'react';

const SubMenuRadio = ({ label, value, disabled = false }) => {
    return (
        <FormControlLabel
            value={value}
            label={label}
            control={
                <Radio
                    className="map-controller-radio"
                    disableFocusRipple
                    disableRipple
                    disableTouchRipple
                    size="small"
                />
            }
            className="map-controller-radio-label"
            disableTypography
            disabled={disabled}
        />
    );
};

export default SubMenuRadio;
